import {
  differenceInCalendarDays,
  differenceInCalendarWeeks,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  format,
  isWithinInterval,
  subDays,
  subHours,
  subMinutes,
  subMonths,
  subSeconds,
  subWeeks,
  subYears,
} from "date-fns";

export const formatRelativeTimestamp = (date: Date): string => {
  const now = new Date();
  const longTimeAgo = subYears(now, 10);
  const yearAgo = subMonths(now, 12);
  const fourWeeksAgo = subWeeks(now, 4);
  const sixDaysAgo = subDays(now, 6);
  const yesterday = subHours(now, 24);
  const hourAgo = subHours(now, 1);
  const minuteAgo = subMinutes(now, 1);
  const secondAgo = subSeconds(now, 1);

  if (date.getTime() === now.getTime()) {
    return "Now";
  }

  if (isWithinInterval(date, { start: longTimeAgo, end: yearAgo })) {
    return format(date, "MMM yyyy"); // Example: Jan 2023
  }

  if (isWithinInterval(date, { start: yearAgo, end: fourWeeksAgo })) {
    return format(date, "MMM d"); // Example: Oct 1
  }

  if (isWithinInterval(date, { start: fourWeeksAgo, end: sixDaysAgo })) {
    return `${differenceInCalendarWeeks(now, date)}w`; // Example: 1w
  }

  if (isWithinInterval(date, { start: sixDaysAgo, end: yesterday })) {
    return `${differenceInCalendarDays(now, date)}d`; // Example: 5d
  }

  if (isWithinInterval(date, { start: yesterday, end: hourAgo })) {
    return `${differenceInHours(now, date)}h`; // Example: 12h
  }

  if (isWithinInterval(date, { start: hourAgo, end: minuteAgo })) {
    return `${differenceInMinutes(now, date)}m`; // Example: 35m
  }

  if (isWithinInterval(date, { start: minuteAgo, end: secondAgo })) {
    return `${differenceInSeconds(now, date)}s`; // Example: 15s
  }

  return "";
};
